import { constants } from '..';

const setXlsLoadingAction = flag => ({
  type: constants.download.SET_XLS_LOADING,
  flag,
});

const setXmlLoadingAction = flag => ({
  type: constants.download.SET_XML_LOADING,
  flag,
});

const getExportsAction = () => ({
  type: constants.download.GET_EXPORTS,
});

const setExportsAction = exports => ({
  type: constants.download.SET_EXPORTS,
  exports,
});

const setExportsLoadingAction = flag => ({
  type: constants.download.SET_EXPORTS_LOADING,
  flag,
});

const trackExportAction = exportItem => ({
  type: constants.download.TRACK_EXPORT,
  exportItem,
});

const upsertExportAction = exportItem => ({
  type: constants.download.UPSERT_EXPORT,
  exportItem,
});

const cancelExportAction = id => ({
  type: constants.download.CANCEL_EXPORT,
  id,
});

const setDismissedExportIdsAction = ids => ({
  type: constants.download.SET_DISMISSED_EXPORT_IDS,
  ids,
});

const clearCompletedExportsAction = () => ({
  type: constants.download.CLEAR_COMPLETED_EXPORTS,
});

const setExportQueueOpenAction = isOpen => ({
  type: constants.download.SET_EXPORT_QUEUE_OPEN,
  isOpen,
});

const setAsyncExportResult = result => ({
  type: constants.download.SET_ASYNC_EXPORT_RESULT,
  result,
});

const fetchExportedFile = (filename, url) => ({
  type: constants.download.FETCH_EXPORTED_FILE,
  filename,
  url,
});

const setDownloadedFile = fileContent => ({
  type: constants.download.SET_DOWNLOADED_FILE,
  fileContent,
});

const setQrLoadingAction = flag => ({
  type: constants.download.SET_QR_LOADING,
  flag,
});

const connectSocketAction = flag => ({
  type: constants.download.CONNECT_SOCKET,
  flag,
});

const cleanDownload = () => ({
  type: constants.download.CLEAN_DOWNLOAD,
});

export const downloadActions = {
  setXlsLoadingAction,
  setQrLoadingAction,
  getExportsAction,
  setExportsAction,
  setExportsLoadingAction,
  trackExportAction,
  upsertExportAction,
  cancelExportAction,
  setDismissedExportIdsAction,
  clearCompletedExportsAction,
  setExportQueueOpenAction,
  setAsyncExportResult,
  fetchExportedFile,
  setDownloadedFile,
  cleanDownload,
  connectSocketAction,
  setXmlLoadingAction,
};
